import React, { useState } from "react";
import CreateNotification from "../../Notifications/api/CreateNotification";
import ChangeOrderStatus from "../api/ChangeOrderStatus";

const OrderRowPop = ({ order, togglePop, setStatus }) => {
  const [orderStatus, setOrderStatus] = useState(order.status);
  const [orderContent, setOrderContent] = useState("");

  // sending Notification for User
  const sendNotification = async () => {
    let data = {
      distributorid: `${order.distributorId}`,
      title: "تغيير حالة الطلب ",
      content: orderContent,
    };
    await CreateNotification(data);
  };

  // editing Status for Order
  const changeOrderStatus = async () => {
    let data = { orderId: order.orderId, orderStatus: orderStatus };
    await ChangeOrderStatus(data);
  };
  const handlerForm = async (e) => {
    e.preventDefault();
    changeOrderStatus();
    sendNotification();
    setStatus(orderStatus);
    togglePop();
  };
  return (
    <>
      <div className="fixed w-[45%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg rounded-lg  border">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={() => togglePop()}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        <div className="my-2">
          <h2 className="text-xl mb-4">
            تغيير الحالة للطلب رقم
            <span className="underline text-blue-500 mx-4">{order.orderId}</span>
          </h2>
          <form className="flex flex-col items-end my-2" onSubmit={handlerForm}>
            <div className="mb-2 w-full text-right">
              <label className="block mb-2 text-md">حالة الطلب الجديدة</label>
              <select
                value={orderStatus}
                onChange={(e) => {
                  setOrderStatus(Number(e.target.value));
                }}
                className="w-full p-2 border rounded-lg mb-2"
                dir="rtl"
              >
                <option value="1">طلب جديد</option>
                <option value="2">قيد التنفيذ</option>
                <option value="3">تم الإنتهاء منه</option>
              </select>
            </div>
            <div className="mb-2 w-full">
              <label className="block mb-2 text-md text-right">سبب تغير حالة الطلب</label>
              <textarea
                type="text"
                rows="4"
                className="w-full p-2 border rounded-lg mb-2"
                dir="rtl"
                required
                value={orderContent}
                onChange={(e) => {
                  setOrderContent(e.target.value);
                }}
              ></textarea>
            </div>
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-lg">
              إرسال
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default OrderRowPop;
